import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { IResource, Resource } from "@/model/Resource";
import { BannerOption, WorkPermitFormType } from "@/model/Enums";

export interface IClientLookup {
    id: string;
    description: string;
    workPermitFormTypes: Array<WorkPermitFormType>;
    deleted: Date;
}

export interface IClient {
    id: string;
    name: string;
    host: string;
    logoResourceID: number;
    bannerOption: BannerOption;
    bannerColour: string;
    buttonColour: string;
    errorColour: string;
    noteColour1: string;
    noteColour2: string;
    noteColour3: string;
    noteColour4: string;
    siteListHtml: string;
    workPermitFormTypes: Array<WorkPermitFormType>;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;

    logoResource: IResource;
}

export class Client implements IClient {

    constructor(data?: IClient) {
        if (data) this.update(data);
    }

    update(data: IClient): IClient {
        mapData(data, {
            root: () => this,
            logoResource: (data: IResource) => this.logoResource.update(data)
        });
        return this;
    }

    id: string = Utils.emptyGuidValue;
    name: string = "";
    host: string = "";
    logoResourceID: number = 0;
    bannerOption: BannerOption = BannerOption.Solid;
    bannerColour: string = "";
    buttonColour: string = "";
    errorColour: string = "";
    noteColour1: string = "";
    noteColour2: string = "";
    noteColour3: string = "";
    noteColour4: string = "";
    siteListHtml: string = "";
    workPermitFormTypes: Array<WorkPermitFormType> = [];
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;

    logoResource: Resource = new Resource();

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}
